module.exports = __webpack_public_path__ + "static/media/mono_front_color_bg.ec8f645b.png";